import React from "react";
import Highcharts, { color, reduce } from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import { MoneyDisplayHelper } from "../../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { CurrencyCode } from "../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";


interface ITransfersDonutChartProps{
    data: any[];
}


export const TransfersDonutChart = (props: ITransfersDonutChartProps) => {
    const total = () : number => {
        let sum = 0;
        props.data?.forEach(d => sum += d.value.Amount);
        return sum;
    }

    const colorOptions = () => {
        const options = props.data?.map(({ color }) => color);
        return options;
    }

    const chartData = () => {
        const chartData = [];
        props.data?.forEach(d => chartData.push([d.label, d.allocation]));
        return chartData;
    }

    const options: Highcharts.Options = {

        chart: {
            renderTo: 'container',
            className: 'ml-auto mr-auto',
            type: 'pie',
            backgroundColor: 'transparent',   
            height: 275,
            width: 275,  
            marginTop: 0,
            marginBottom: 0,
            spacingTop: 0,
            spacingBottom: 0
        },
        title: {
            text: ''
        },
        navigator: {
            enabled: false 
        },
        rangeSelector: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        yAxis: {
            title: {
                text: 'Total percent market share'
            }
        },
        plotOptions: {
            pie: {
                shadow: false,
                borderColor: 'transparent'
            }
        },
        tooltip: {
            formatter: function() {
                return '<b>'+ this.point.name +'</b>: '+ '<br>' + this.y +' %' + '<br>' + 
                    MoneyDisplayHelper.FromatMoneyDisplay(
                        props.data.find(x => x.ArrangementType = this.point.name).value.Amount,
                        CurrencyCode.GBP,
                        true,
                        2
                    );
            }
        },
        series: [{ 
            name: 'Asset Classes',
            type: "pie",
            data: chartData(),
            size: '100%',
            innerSize: '92%',
            selected: false,
            showInLegend: false,
            dataLabels: {
                enabled: false
            }
        }],
        colors: colorOptions()
    }

    Highcharts.setOptions({
        colors: colorOptions()
    });

    

    return (
        <>
            <div className="row">
                <div className="col-12 col-md-auto text-center">        
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={options}
                    />
                </div>
                <div className="col-12 col-md-fluid col-middle">
                    <div className="pl-30 pr-30">
                        <table className="data-table asset-class-table mb-0">
                            <thead>
                                <tr>
                                    {/* <th><span className="sr-only">Asset class</span></th> */}
                                    <th className="cell-left">Type</th>
                                    <th className="cell-right">Allocation</th>
                                    <th className="cell-right">Value</th>
                                </tr>
                            </thead>
                            <tbody>
                                {props.data?.map((row, index) => {
                                    return (
                                        <tr key={index}>
                                            <td><span className="product-color" aria-hidden={true} style={{ borderColor: row.color }}></span>{row.label}</td>
                                            <td className="cell-right">{row.allocation}%</td>
                                            <td className="cell-right">
                                                {MoneyDisplayHelper.FromatMoneyDisplay(
                                                    row.value.Amount,
                                                    CurrencyCode.GBP,
                                                    true,
                                                    2
                                                )}
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colSpan={2} className="cell-total"></td>
                                    <td className="cell-value cell-right">
                                        {MoneyDisplayHelper.FromatMoneyDisplay(
                                            total(),
                                            CurrencyCode.GBP,
                                            true,
                                            2
                                        )}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>                    
                </div>
            </div>
        </>
    )
}